import React from 'react'
import viewableSlides from '../../common/lib/viewable-slides'
import optimizedWindowResize from '../../common/lib/optimized-window-resize'

export default (Component) => {
  return (
    class WithTotalViewableSlides extends React.Component {
      constructor(props) {
        super(props)

        this.state = {
          totalViewableSlides: viewableSlides(),
        }
      }

      componentDidMount() {
        optimizedWindowResize.add('totalViewableSlides', () => {
          this.setState({
            totalViewableSlides: viewableSlides(),
          })
        })
      }

      componentWillUnmount() {
        optimizedWindowResize.remove('totalViewableSlides')
      }

      shouldComponentUpdate(nextProps, nextState) {
        const currentTotalViewableSlides = this.state.totalViewableSlides
        const newTotalViewableSlides = nextState.totalViewableSlides

        if (newTotalViewableSlides === currentTotalViewableSlides) {
          return false
        }

        return true
      }

      render() {
        return <Component totalViewableSlides={this.state.totalViewableSlides} {...this.props} />
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/desktop/components/with-total-viewable-slides.js